var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a-drawer',{attrs:{"title":"现场图片","placement":"right","visible":_vm.visible,"width":"500","body-style":{ paddingBottom: '80px' },"maskClosable":false},on:{"close":_vm.onClose}},[_c('Viewer',{staticClass:"images h-box f-c-v",staticStyle:{"flex-wrap":"wrap"},attrs:{"images":_vm.shopImages}},_vm._l((_vm.shopImages),function(url,index){return _c('div',{key:index,staticClass:"base-image border-base radius-base m-r-min m-b-min h-box f-c-v bg base-shop-image"},[_c('img',{attrs:{"alt":"店铺图片","src":url}})])}),0),_c('div',{style:({
    position: 'absolute',
    right: 0,
    bottom: 0,
    width: '100%',
    borderTop: '1px solid #e9e9e9',
    padding: '10px 16px',
    background: '#fff',
    textAlign: 'right',
    zIndex: 1,
  })},[_c('a-button',{style:({ marginRight: '8px' }),on:{"click":_vm.onClose}},[_vm._v(" 关闭 ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }